import {renderBandTextPng} from './band-text'
import {renderCode128Png, renderDataMatrixPng} from './data-matrix'
import type {PreparationLabelCaptions} from './preparation-label-pdf'
import type {LabelTextKey, PreparationLabelData} from './types'

export async function renderLabelAssets(label: PreparationLabelData) {
  return {
    dataMatrixSrc: renderDataMatrixPng(label.dataMatrixPayload),
    linearBarcodeSrc: label.linearBarcodePayload ? renderCode128Png(label.linearBarcodePayload) : null,
    bandTextSrc: label.bandText ? await renderBandTextPng(label.bandText, label.size) : null,
  }
}

export function getLabelCaptions(t: (key: LabelTextKey) => string): PreparationLabelCaptions {
  return {
    useBy: t('preparation_label.use_by'),
    storage: t('preparation_label.storage'),
    productionNo: t('preparation_label.production_no'),
    produced: t('preparation_label.produced'),
    preparedBy: t('preparation_label.prepared_by'),
    administration: t('preparation_label.administration'),
    routeWarning: t('preparation_label.route_warning'),
  }
}
